import React, { Component, Fragment } from 'react';
import { View } from 'react-native';
import { connect } from 'react-redux';

import Text from '../../react-component/textComponent';
import ChangeStatus from '../../react-component/changeStatus';
import ButtonLoading from '../../react-component/buttonLoading';
import { renderTitle } from './utils';

import ButtonBack from './buttonBack';

import Colors from '../../config/Colors';
import Layout from '../../config/Layout';

import styles from './styles';

import Modal from './../modal';

import { PEDIDO_STATUS } from '../../constants/status-pedido';
import { Add, Close } from '@mui/icons-material';

class HeaderBar extends Component {
    state = {
        modalConfirmacaoSeparacao: false,
        modalConfirmacaoCancelamento: false,
        isLoading: false
    };

    constructor(props) {
        super(props);

        this.confirmarSeparacao = this.confirmarSeparacao.bind(this);
        this.confirmarCancelamento = this.confirmarCancelamento.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.closeModalCancelamento = this.closeModalCancelamento.bind(this);
    }

    confirmarSeparacao(status) {
        const { idStatusPedido } = status;

        if (idStatusPedido === PEDIDO_STATUS.SEPARADO) {
            this.setState({ modalConfirmacaoSeparacao: true });
        } else {
            this.props.onStatusChange(null, 0);
        }
    }

    confirmarCancelamento() {
        this.setState({ modalConfirmacaoCancelamento: true });
    }

    async separarPedido() {
        this.setState({ isLoading: true });

        await this.props.onStatusChange(null, 0);

        this.setState({ isLoading: false });
    }

    async cancelarPedido() {
        this.setState({ isLoading: true });

        await this.props.onStatusChange(PEDIDO_STATUS.CANCELADO);

        this.setState({ isLoading: false });
    }

    closeModal() {
        this.setState({ modalConfirmacaoSeparacao: false });
    }

    closeModalCancelamento() {
        this.setState({ modalConfirmacaoCancelamento: false });
    }

    render() {
        const {
                navigation,
                hasStyle = true,
                hasBack = true,
                backNavigation = false,
                hasClose = false,
                hasChangeStatus = false,
                statusList = [],
                listItens,
                returnCallback,
                currentStatus = '',
                children,
                disableStatusButton = true
            } = this.props,
            customStyle = {
                paddingLeft: hasClose || !hasBack ? 16 : 0
            };

        const addProdutoText = () => (
            <View style={styles.addProdutoButton}>
                <Add sx={{
                    fontSize: 20,
                    color: Colors.white
                  }} 
                />
                <Text style={{ color: Colors.white }}> Produto</Text>
            </View>
        );

        const imprimirPedidoText = () => (
            <View style={styles.addProdutoButton}>
                <Text style={{ color: Colors.white }}>Imprimir pedido</Text>
            </View>
        );

        return (
            <Fragment>
                {this.state.modalConfirmacaoSeparacao && (
                    <Modal
                        size="textModal"
                        title={renderTitle({ type: 1, listItens })}
                        isOpen={this.state.modalConfirmacaoSeparacao}
                        onClose={this.closeModal}
                        onSave={() => this.separarPedido()}
                        saveText="Separar pedido"
                        isSaveButtonLoading={this.state.isLoading}
                    >
                        <div
                            style={{
                                textAlign: 'center'
                            }}
                        >
                            <p
                                style={{
                                    fontSize: '1.6rem',
                                    fontFamily: 'NunitoSans-Regular'
                                }}
                            >
                                {renderTitle({ type: 0, listItens })}
                            </p>
                        </div>
                    </Modal>
                )}

                {this.state.modalConfirmacaoCancelamento && (
                    <Modal
                        size="textModal"
                        title={'Deseja cancelar esse pedido?'}
                        isOpen={this.state.modalConfirmacaoCancelamento}
                        onClose={this.closeModalCancelamento}
                        onSave={() => this.cancelarPedido()}
                        saveText="Cancelar pedido"
                        isSaveButtonLoading={this.state.isLoading}
                    >
                        <div
                            style={{
                                textAlign: 'center'
                            }}
                        >
                            <p
                                style={{
                                    fontFamily: 'NunitoSans-Regular',
                                    fontSize: '1.6rem'
                                }}
                            >
                                {'Não é possível reverter essa operação'}
                            </p>
                        </div>
                    </Modal>
                )}

                <View
                    style={[
                        styles.header,
                        this.props.style,
                        hasStyle && styles.headerBorderBottom
                    ]}
                >
                    {!hasClose && hasBack && (
                        <ButtonBack
                            iconName="arrow-left"
                            navigation={navigation}
                            returnCallback={returnCallback}
                            backNavigation={backNavigation}
                        />
                    )}
                    {
                        <View style={[styles.content, customStyle]}>
                            {children}
                        </View>
                    }

                        <ButtonLoading
                            label={'Cancelar'}
                            style={styles.buttonCancelar}
                            disabled={currentStatus === PEDIDO_STATUS.CANCELADO}
                            onPress={() => this.confirmarCancelamento()}
                        />

                    {hasChangeStatus && statusList.length === 1 && (
                        <div style={{ display: 'flex' }}>
                            <ButtonLoading
                                label={imprimirPedidoText()}
                                style={styles.buttonCadastro}
                                onPress={() => this.props.buscarPdfPedido()}
                            />

                            {Layout.isDesktop && (
                                <View style={styles.buttonContainer}>
                                    <ButtonLoading
                                        label={addProdutoText()}
                                        style={styles.buttonCadastro}
                                        onPress={() =>
                                            this.props.openModalAddProduto()
                                        }
                                    />
                                </View>
                            )}

                            <ButtonLoading
                                label={statusList[0].dsStatusPedido}
                                style={styles.buttonSeparacao}
                                disabled={disableStatusButton}
                                onPress={() =>
                                    this.confirmarSeparacao(statusList[0])
                                }
                            />
                        </div>
                    )}
                    {hasChangeStatus && statusList.length > 1 && (
                        <Fragment>
                            <ButtonLoading
                                label={imprimirPedidoText()}
                                style={styles.buttonCadastro}
                                onPress={() => this.props.buscarPdfPedido()}
                            />

                            <ButtonLoading
                                label={'Sincronizar'}
                                style={styles.buttonCadastro}
                                disabled={this.props.isSincronizarDisabled}
                                isLoading={this.props.isSincronizarLoading}
                                onPress={() => this.props.onPressSincronizar()}
                            />

                            <ChangeStatus
                                statusList={statusList}
                                currentStatus={currentStatus}
                                onStatusChange={this.props.onStatusChange}
                            />
                        </Fragment>
                    )}
                    {hasClose && (
                        <ButtonBack Icon={Close} navigation={navigation} />
                    )}
                </View>
            </Fragment>
        );
    }
}

const mapStateToProps = ({ user }) => ({
    user
});

export default connect(mapStateToProps, null)(HeaderBar);
